import { style } from '@vanilla-extract/css'
import { vars } from '~/styles/theme.css'

export const box = style({
  background: vars.paper.background,
  borderRadius: vars.paper.radius,
  border: vars.paper.border,
  minWidth: 0,
  color: vars.color.dark,
  fontWeight: vars.font.content.weight,
  fontSize: vars.font.content.size
})

export const paperContentPadding = style({
  padding: vars.paper.padding
})
